import { AddIcon, Button } from '@thefarmersfront/kitchen';

type TypeProductSalesCellRendererProps = {
  onClick: () => void;
};

/** 판매처 추가 버튼 셀. */
const ProductSalesCellRenderer = ({ onClick }: TypeProductSalesCellRendererProps) => (
  <Button size="tiny" color="tertiary" onClick={onClick} leftIcon={<AddIcon size={16} />}>
    판매처
  </Button>
);

export default ProductSalesCellRenderer;
